import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Head from 'next/head';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Footer from '@/components/common/widgets/Footer';
import HeroSection from '@/components/homepage/HeroSection';
import Layout from '@/components/common/layouts/Layout';
import ActionSection from './orgpage/ActionSection';
import IntroSection from './orgpage/IntroSection';
import FeatureSection from './orgpage/FeatureSection';
import OrgSignupSection from './orgpage/OrgSignupSection';
import SponsorsSection from './orgpage/SponsorsSection';

function OrgPage() {
  return (
    <Layout>
      <Head>
        <title>Big & Mini: Organization Page</title>
        <meta name="description" content="Join Big & Mini as an organization. It's simple and easy." />
      </Head>
      <div id="about">
        <ParallaxProvider>
          <HeroSection
                //  image = "/images/app-mockup-homepage.jpg"
            image="/images/Mockups/Smartphone/smartmockups_kcihv44k.jpg"
                // image = "/images/teamphotos/IMG_4463.PNG"
            alt="Person using Big & Mini's mobile application"
            topSpace={(
              <div>
                <br />
              </div>
                )}
            title="Sign up as an Organization"
            description="Track user engagement, approve volunteers, and schedule group activities."
            otherContent={(
              <div>
                <br />
                {/* <a href = "orgsignup" className="hero-button">
                Get in touch
            </a> */}
                <AnchorLink className="hero-button" href="#contact-form">Get in touch</AnchorLink>
              </div>
                )}
          />
        </ParallaxProvider>
        <IntroSection />
        <FeatureSection />
        {/* <SponsorsSection/> */}

        <OrgSignupSection />

        {/* <ActionSection /> */}
        <Footer />
      </div>
    </Layout>
  );
}

export default OrgPage;
